import { get } from 'lodash';

import { TransferClientError } from '../../../errors';

import stringOrUndefined from './stringOrUndefined';

const createErrorHandler = (requestUrl: string) => (err: unknown) => {
  let clientError: TransferClientError;

  if (err instanceof TransferClientError) {
    clientError = err;
  }

  // Convert native fetch connection error
  else {
    clientError = new TransferClientError({
      detail: stringOrUndefined(get(err, 'message')) || String(err),
      code:
        stringOrUndefined(get(err, 'code') || get(err, 'name')) ||
        'ConnectionError',
      id: stringOrUndefined(get(err, 'id')),
      requestUrl,
    });
  }

  throw clientError;
};

export default createErrorHandler;
